// src/services/turniService.js
import apiClient from './apiClient';

export const fetchTurniByMonth = async (monthYear) => {
    try {
        const response = await apiClient.get(`/turni.php?action=get_month&month=${monthYear}`);
        if (response.data.success) return response.data.data;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore nel fetch turni', err);
        throw err;
    }
};

export const saveTurno = async (shiftData) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'save_shift', ...shiftData });
        if (response.data.success) return true;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore durante il salvataggio turno:', err);
        throw err;
    }
};

export const updateTurno = async (shiftData) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'update_shift', ...shiftData });
        if (response.data.success) return true;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore durante l\'aggiornamento turno:', err);
        throw err;
    }
};

export const deleteTurno = async (id) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'delete_shift', id });
        if (response.data.success) return true;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore durante eliminazione turno:', err);
        throw err;
    }
};

export const requestFerie = async (ferieData) => {
    try {
        if (ferieData.file && (Array.isArray(ferieData.file) ? ferieData.file.length > 0 : true)) {
            const formData = new FormData();
            formData.append('action', 'request_leave');
            formData.append('start_date', ferieData.start_date);
            formData.append('end_date', ferieData.end_date);
            formData.append('motivazione', ferieData.motivazione || '');
            formData.append('operator_name', ferieData.operator_name);
            formData.append('leave_type', ferieData.type || 'Ferie');

            if (Array.isArray(ferieData.file)) {
                ferieData.file.forEach(f => formData.append('files[]', f));
            } else {
                formData.append('files[]', ferieData.file);
                formData.append('file', ferieData.file);
            }

            const response = await apiClient.post('/turni.php', formData);
            if (response.data.success) return true;
            throw new Error(response.data.error);
        } else {
            const response = await apiClient.post('/turni.php', {
                action: 'request_leave',
                leave_type: ferieData.type || 'Ferie',
                ...ferieData
            });
            if (response.data.success) return true;
            throw new Error(response.data.error);
        }
    } catch (err) {
        console.error('Errore richiesta ferie:', err);
        throw err;
    }
};

export const timbraTurno = async (id) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'timbra_shift', id });
        if (response.data.success) return true;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore durante la timbratura turno:', err);
        throw err;
    }
};

export const fetchFerieRequests = async () => {
    try {
        const response = await apiClient.get('/turni.php?action=get_leave_requests');
        if (response.data.success) return response.data.data;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore recupero richieste ferie:', err);
        throw err;
    }
};

export const fetchShiftRanges = async () => {
    try {
        const response = await apiClient.get('/turni.php?action=get_shift_ranges');
        if (response.data.success) return response.data.data;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore fetch intervalli fissi:', err);
        throw err;
    }
};

export const saveShiftRange = async (data) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'save_shift_range', ...data });
        if (response.data.success) return response.data.batch_id;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore salvataggio intervallo fisso:', err);
        throw err;
    }
};

export const updateShiftRange = async (data) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'update_shift_range', ...data });
        if (response.data.success) return true;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore aggiornamento intervallo fisso:', err);
        throw err;
    }
};

export const deleteShiftRange = async (batch_id) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'delete_shift_range', batch_id });
        if (response.data.success) return true;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore eliminazione intervallo fisso:', err);
        throw err;
    }
};

export const updateFerieRequestStatus = async (id, status) => {
    try {
        const response = await apiClient.post('/turni.php', { action: 'update_leave_status', id, status });
        if (response.data.success) return true;
        throw new Error(response.data.error);
    } catch (err) {
        console.error('Errore aggiornamento richiesta ferie:', err);
        throw err;
    }
};
